import { render, staticRenderFns } from "./FormRatingNumberOfStars.vue?vue&type=template&id=49f806ac&"
import script from "./FormRatingNumberOfStars.vue?vue&type=script&lang=js&"
export * from "./FormRatingNumberOfStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports